import { Empty, Flex } from "antd";
import { FC } from "react";
import { TaskRejectProducts } from "tm-shared/types";

import { InfoRowList } from "@/components/TasksModals/components/InfoRowList";
import { PrimaryText, SecondaryText } from "@/components/Typography/Styled";

import { ProductCard } from "../components/ProductCard";
import { TaskViewModal } from "../TaskViewModal";

interface RejectProductsViewModalProps {
    task: TaskRejectProducts;
    onClose: () => void;
}

export const RejectProductsViewModal: FC<RejectProductsViewModalProps> = ({
    task,
    onClose,
}) => {
    const payload = task?.payload;
    const completedAt = task?.completedAt;

    if (!payload || !completedAt) return null;

    const paymentForm = payload?.paymentForm ?? "не вказана";
    const rejectProducts = payload.products;

    const infoRows = [
        { label: "Всього товарів:", value: `${rejectProducts.length} шт.` },
        { label: "Тип оплати:", value: `Форма ${paymentForm}` },
    ];

    return (
        <TaskViewModal
            title={task.name}
            onClose={onClose}
            taskInfo={task?.info}
        >
            <Flex vertical gap={16}>
                <InfoRowList items={infoRows} />

                {rejectProducts.length === 0 ? (
                    <Empty
                        description="Немає продуктів для відображення"
                        style={{ padding: "40px 0" }}
                    />
                ) : (
                    <Flex vertical gap={12}>
                        {rejectProducts.map((p) => (
                            <ProductCard key={p.barcode} product={p}>
                                <Flex gap={4}>
                                    <SecondaryText>Повернення:</SecondaryText>

                                    <PrimaryText
                                        fontWeight="500"
                                        fontSize={16}
                                        $textColor="accent"
                                    >
                                        {p.count} шт.
                                    </PrimaryText>
                                </Flex>
                            </ProductCard>
                        ))}
                    </Flex>
                )}
            </Flex>
        </TaskViewModal>
    );
};
